/**
 * About Us Page — Scroll Reveal & Parallax Controller
 * L'Orient Haus Premium Animations
 *
 * Uses IntersectionObserver for scroll-triggered reveals.
 * Adds subtle parallax depth to media images on scroll.
 * Fully respects prefers-reduced-motion.
 */
(function () {
  'use strict';

  /* Bail out if user prefers reduced motion */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Add the animation scope class to <html> */
  document.documentElement.classList.add('about-animations');

  /* ---- Scroll Reveal via IntersectionObserver ---- */
  var revealTargets = document.querySelectorAll(
    '.hero-wrapper, .media-with-content'
  );

  if (revealTargets.length === 0) return;

  var revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.15,
      rootMargin: '0px 0px -60px 0px'
    }
  );

  revealTargets.forEach(function (el) {
    revealObserver.observe(el);
  });

  /* ---- Subtle Parallax on Media Images ---- */
  var parallaxImages = document.querySelectorAll(
    '.media-with-content .media-block img'
  );

  if (parallaxImages.length > 0) {
    var ticking = false;

    function updateParallax() {
      var viewportHeight = window.innerHeight;

      parallaxImages.forEach(function (img) {
        var rect = img.getBoundingClientRect();
        /* Only process images in or near viewport */
        if (rect.bottom < -100 || rect.top > viewportHeight + 100) return;

        /* Calculate scroll progress: 0 = entering bottom, 1 = exiting top */
        var progress = 1 - (rect.top + rect.height) / (viewportHeight + rect.height);
        /* Map to a small Y offset: -12px to +12px */
        var yOffset = (progress - 0.5) * 24;

        img.style.transform = 'translateY(' + yOffset.toFixed(1) + 'px)';
      });

      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          requestAnimationFrame(updateParallax);
          ticking = true;
        }
      },
      { passive: true }
    );
  }

  /* ---- Stagger delay for alternating sections ---- */
  var mediaSections = document.querySelectorAll('.media-with-content');
  mediaSections.forEach(function (section, index) {
    section.style.setProperty('--reveal-delay', index * 50 + 'ms');
  });
})();
